import { useState } from "react";
import { useHistory } from "react-router-dom";

export const useWords = (lang) => {
  const [langWords, setLangWords] = useState({});
  const history = useHistory();
  import(`../lang/${lang}`)
    .then((module) => setLangWords(module.lang))
    .catch((err) => {
      console.error(err);
      history.replace("/error");
    });

  return langWords;
};
